import React, { Fragment } from 'react'
import Markdown from 'markdown-it'

import { formatDate } from './formatDate'

const md = new Markdown({linkify: true});

class CVPosition extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isOpen: props.initiallyOpen,
    }
  }

  render() {
    const {
      position,
      organization,
      description,
      location,
      startDate,
      endDate,
      summary,
      highlights,
    } = this.props

    const { isOpen } = this.state

    return (
      <div className="job">
        <div
          className="accordion"
          onClick={() => {
            this.setState(({ isOpen }) => ({ isOpen: !isOpen }))
          }}
          style={{ display: 'flex' }}
        >
          <div>
            <h3>
              {position}, {organization}
            </h3>
            <h4>
              {formatDate(startDate)} - {endDate && formatDate(endDate)}
              {location ? ` | ${location}` : ''}
            </h4>
          </div>
          <div style={{ padding: '2px 8px' }}>
            <i className={`fa fa-chevron-${isOpen ? 'down' : 'right'}`} />
          </div>
        </div>
        {isOpen ? (
          <Fragment>
            {description && <p dangerouslySetInnerHTML={{
                __html: md.renderInline(description),
              }}></p>}
            {summary && <p dangerouslySetInnerHTML={{
                __html: md.renderInline(summary),
              }}></p>}
            {highlights && highlights.length
              ? [
                  <h4 key="header">HIGHLIGHTS</h4>,
                  <ul key="list">
                    {highlights.map((highlight) => (
                      <li key={highlight} dangerouslySetInnerHTML={{
                          __html: md.renderInline(highlight),
                        }}></li>
                    ))}
                  </ul>,
                ]
              : null}
          </Fragment>
        ) : null}
      </div>
    )
  }
}

CVPosition.defaultProps = {
  initiallyOpen: false,
}

export default CVPosition



// WEBPACK FOOTER //
// ./src/components/cv/CVPosition.js